import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";
import { ContratosEntity } from "../entities/contratistas_entity";



@Pipe({
    name: "dataFilterContrato"
})
export class DataFilterPipe implements PipeTransform {

    transform(array: ContratosEntity[], query: string): any {
        if (query) {
            return _.filter(array, row=> (row.NumeroContrato+"").indexOf((query)) > -1);
        }
        return array;
    }
}

@Pipe({
    name: "dataFilterEstadoSeg"
})
export class DataFilterPipe2 implements PipeTransform {

    transform(array: ContratosEntity[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.EstadoSeguro+"")==(query)));
        }
        return array;
    }
}
@Pipe({
    name: "dataFilterEstadoContrato"
})
export class DataFilterPipe3 implements PipeTransform {

    transform(array: ContratosEntity[], query: string): any {      
        if (query) {
            return _.filter(array, row=> ((row.Estado+""))==((query)));
        }
        return array;
    }
}




// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/contratistas/contratistas.filter.ts